// extracted by mini-css-extract-plugin
export default {"wrapper":"Navigation_wrapper__vKHUi","container":"Navigation_container__oqhZU","navs":"Navigation_navs__DsvJI","btn":"Navigation_btn__8tnoP","current":"Navigation_current__kqrAA"};